import React from 'react';
import { Button } from '../../../../components/ui/button';
const NewBlogWarning = ({
  setVisibleEditModel,
}: {
  setVisibleEditModel: () => void;
}) => {
  return (
    <div className="z-50 bg-black/20">
      <div className="fixed left-1/2 top-1/2  w-[400px]  lg:w-[28vw]  -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background p-[25px] text-text-primary">
        <div className="text-xl text-primary font-bold">Warning</div>
        <div className="mb-5 mt-2.5 text-[15px] leading-normal text-mauve11">
          Clicking the Apply button will automatically generate a new blog for
          you
        </div>
        <div className="mt-[25px] gap-4 flex justify-end">
          <div onClick={setVisibleEditModel}>
            <Button
              variant={'customSecondary'}
              className="bg-secondary"
              size={'sm'}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewBlogWarning;
